import React from 'react'
import ReactDOM from 'react-dom'
import { SocialIcon } from 'react-social-icons'

function Socials(props) {
    return (
    <div className="socials">
      <div className="socials-icons">
        <SocialIcon
          fgColor="currentColor"
          bgColor="#9BD770"
          network="github"
          url="https://github.com/tgotowik"
          target="_blank"
        />
      </div>
      <div className="socials-icons">
        <SocialIcon
          fgColor="currentColor"
          bgColor="#9BD770"
          network="gitlab"
          url="https://gitlab.com/tgotowik"
          target="_blank"
        />
      </div>
    </div>
    );
}

export default Socials;